module.exports = ".fxGrid {\r\n  width: 100%;\r\n  flex: 0;\r\n}\r\n\r\n.fxGridHeader {\r\n  flex: 1;\r\n}\r\n\r\n.fxGridCell {\r\n  flex: 1;\r\n}"